module.exports = __webpack_public_path__ + "media/images/teaser-action-map-marker-4-457ac0cb327cc23004a0524508f2542f.svg";